// tslint:disable:max-line-length
import { Component, OnDestroy, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { helpPanelTranslations } from './help-panel.strings';
import { HelpTopic, HelpArticle, HelpPanelState } from '../../models/index';
import { IqsHelpPanelService } from '../../services/help-panel.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'iqs-help-panel',
    templateUrl: './help-panel.component.html',
    styleUrls: ['./help-panel.component.scss']
})
export class IqsHelpPanelComponent implements OnDestroy {

    private subs = new Subscription();

    public topics: HelpTopic[] = [
        {
            title: {
                ru: 'ÐÐ°Ð±Ð»ÑÐ´ÐµÐ½Ð¸Ðµ',
                en: 'Monitoring'
            },
            articles: [
                {
                    title: {
                        ru: 'ÐÐ±ÑÐ¸Ðµ ÑÐ²ÐµÐ´ÐµÐ½Ð¸Ñ',
                        en: 'Common information'
                    },
                    content: {
                        ru: `<iframe width="278" height="156" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/Uu1WW0v8LGo?rel=0" style="margin: 0 auto;"></iframe>
                        <p>ÐÑÐ¸ Ð²ÑÐ¾Ð´Ðµ Ð² ÑÐ¸ÑÑÐµÐ¼Ñ, Ð¿Ð¾ÑÐ»Ðµ ÑÐ¾Ð³Ð¾ ÐºÐ°Ðº Ð¼Ñ Ð²Ð²ÐµÐ»Ð¸ ÑÐ²Ð¾Ð¹ Ð»Ð¾Ð³Ð¸Ð½ Ð¸ Ð¿Ð°ÑÐ¾Ð»Ñ, Ð¼Ñ Ð²Ð¸Ð´Ð¸Ð¼ Ð¿ÐµÑÐ²ÑÐ¹ ÑÐºÑÐ°Ð½: ÐºÐ°ÑÑÑ Ð¿ÑÐµÐ´Ð¿ÑÐ¸ÑÑÐ¸Ñ Ñ Ð¾Ð±ÑÐµÐºÑÐ°Ð¼Ð¸ Ð½Ð° Ð½ÐµÐ¹, Ð¿Ð°Ð½ÐµÐ»Ñ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ¾Ð² ÑÐ»ÐµÐ²Ð° Ð¸ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¿ÑÐ¾Ð¸ÑÑÐµÑÑÐ²Ð¸Ð¹ cÐ¿ÑÐ°Ð²Ð°.</p>
                        <p>ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ¾Ð² ÑÐ¸ÑÑÐµÐ¼Ñ Ð¼Ñ Ð²Ð¸Ð´Ð¸Ð¼ 7 ÑÐ°Ð·Ð´ÐµÐ»Ð¾Ð², "ÐÐ°Ð±Ð»ÑÐ´ÐµÐ½Ð¸Ðµ" Ð°ÐºÑÐ¸Ð²Ð½ÑÐ¹ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ.</p>
                        <p>ÐÐ»Ð°Ð²Ð½ÑÐ¼ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð¼ ÑÑÐ¾Ð³Ð¾ ÑÐºÑÐ°Ð½Ð° ÑÐ»ÑÐ¶Ð¸Ñ ÐºÐ°ÑÑÐ°. Ð¾Ð½Ð° Ð·Ð°Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐµÐ½ÑÑÐ°Ð»ÑÐ½Ð¾Ðµ Ð¼ÐµÑÑÐ¾, Ð½Ð° Ð½ÐµÐ¹ Ð¼ Ð¼Ñ Ð²Ð¸Ð´Ð¸Ð¼ ÑÐ¾ÑÐºÐ¸ Ð¾Ð±ÑÐµÐºÑÐ¾Ð² Ð¸ Ð³ÐµÐ¾Ð·Ð¾Ð½Ñ ÑÐ°Ð·Ð½Ð¾Ð¹ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸. Ð ÑÐ³Ð»Ð°Ñ ÐºÐ°ÑÑÑ ÑÐ°ÑÐ¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ñ Ð²ÑÐ¿Ð¾Ð¼Ð¾Ð³Ð°ÑÐµÐ»ÑÐ½ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÑ.</p>
                        `,
                        en: `<iframe width="278" height="156" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/hSVQOt2ooRk?rel=0" style="margin: 0 auto;"></iframe>
                        <p>After successfully logging into the system, the first thing you will see is the screen with the map in the middle, the Tools Panel on the left side, and the Incident Panel on the right side. Looking at the Tools Panel, we see 7 tools, and one of them, Monitoring, is currently active.</p>
                        <p>In Monitoring, we see the map of the work organization, objects and zones on the map. In the corners are additional instruments: a search box, object panel, fab tool, and zoom buttons.</p>
                        <p>Using these buttons we can zoom in and out of the map.</p>
                        <p>Map controls here are the same as in other online map applications, and gestures are supported on touch screen devices.</p>
                        <p>You can have several locations defined on your map and quickly move between them using the Locations tool. Click 'Locations' in the Fab tool, and select a location and see the map move to it.</p>
                        `
                    }
                }
            ]
        },
        {
            title: {
                ru: 'ÐÐ±ÑÐµÐºÑÑ Ð½Ð° ÐºÐ°ÑÑÐµ',
                en: 'Objects'
            },
            articles: [
                {
                    title: {
                        ru: 'ÐÐ±ÑÐ¸Ðµ ÑÐ²ÐµÐ´ÐµÐ½Ð¸Ñ',
                        en: 'Common information'
                    },
                    content: {
                        ru: `<iframe width="278" height="156" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/AYnGtY-mlgI?rel=0" style="margin: 0 auto;"></iframe>
                        <p>ÐÐ° ÐºÐ°ÑÑÐµ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ 3 ÑÐ¸Ð¿Ð° Ð¾Ð±ÑÐµÐºÑÐ¾Ð²: Ð¼Ð°ÑÐ¸Ð½Ñ, Ð»ÑÐ´Ð¸ Ð¸ Ð¼ÐµÑÐ°Ð½Ð¸Ð·Ð¼Ñ. ÐÐ½Ð¸ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ ÐºÐ²Ð°Ð´ÑÐ°ÑÐ°Ð¼Ð¸, ÑÑÐµÑÐ³Ð¾Ð»ÑÐ½Ð¸ÐºÐ°Ð¼Ð¸ Ð¸ ÐºÑÑÐ¶Ð¾ÑÐºÐ°Ð¼Ð¸, Ð° Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½ÑÑÐµÐ½Ð¸Ð¸ Ð¼Ð°ÑÑÑÑÐ°Ð±Ð°, Ð² Ð²Ð¸Ð´Ðµ Ð¸ÐºÐ¾Ð½Ð¾Ðº Ð¼Ð°ÑÐ¸Ð½, Ð»ÑÐ´ÐµÐ¹ Ð¸ Ð¼ÐµÑÐ°Ð½Ð¸Ð·Ð¼Ð¾Ð².</p>
                        <p>ÐÐ»Ð¸Ðº Ð½Ð° Ð¸ÐºÐ¾Ð½ÐºÐµ Ð¾Ð±ÑÐµÐºÑÐ°, Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð²ÑÐ´ÐµÐ»Ð¸ÑÑ ÐµÐ³Ð¾. ÐÐ»Ñ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÑÐµÐºÑÐ° Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÑÑÑ Ð¿ÑÑÑ ÐµÐ³Ð¾ Ð´Ð²Ð¸Ð¶ÐµÐ½Ð¸Ñ Ð² Ð²Ð¸Ð´Ðµ ÑÐ·Ð»Ð¾Ð²ÑÑ ÑÐ¾ÑÐµÐº, ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð½ÑÑ Ð»Ð¾Ð¼Ð°Ð½Ð¾Ð¹ Ð»Ð¸Ð½Ð¸ÐµÐ¹. ÐÐ»Ð¸Ðº Ð½Ð° ÑÐ¶Ðµ Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð¼ Ð¾Ð±ÑÐµÐºÑÐµ, Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð¸Ñ ÐµÐ³Ð¾ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ ÑÐ»ÐµÐ¶ÐµÐ½Ð¸Ñ. ÐÑÐ´ÐµÐ»ÐµÐ½Ð½ÑÐ¹ Ð¾Ð±ÑÐµÐºÑ Ð²ÑÐµÐ³Ð´Ð° Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑ Ð¿Ð¾ÑÑÐµÐ´Ð¸Ð½Ðµ ÐºÐ°ÑÑÑ.</p>
                        <p>ÐÐ»Ñ Ð¾ÑÐ¼ÐµÐ½Ñ ÑÐµÐ¶Ð¸Ð¼Ð° ÑÐ»ÐµÐ¶ÐµÐ½Ð¸Ñ, Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ð¹ Ð¾Ð±ÑÐµÐºÑ, Ð¸Ð»Ð¸ Ð¿ÑÐ¾ÑÑÐ¾ ÐºÐ»Ð¸ÐºÐ½ÑÑÑ Ð¼ÑÑÐºÐ¾Ð¹ Ð² Ð»ÑÐ±Ð¾Ð¹ ÑÐ²Ð¾Ð±Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ¾ÑÐºÐµ ÐºÐ°ÑÑÑ.</p>
                        `,
                        en: `<iframe width="278" height="156" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/IFgHpNiYD9Y?rel=0" style="margin: 0 auto;"></iframe>
                        <p>Currently on the map we see three types of objects: people, vehicles and assets. When zoomed out, we see them as small triangles, squares, and circles. When we zoom in, these icons become more informative. Their icons become more distinct and below each icon we now see the objectsâ names and descriptions.</p>
                        <p>We can select an object by clicking on its icon. The object becomes highlighted and there appears a 'trace' of dots behind it. The trace shows where the object has been in the near past. The trace follows the object as it move.</p>
                        <p>To avoid highlighted objects from moving out of our view, we can use the systemâs Autofocus mode. If you click the selected object once more, the objectâs icon will change again and the map will center on the object and move automatically as the object moves. This can come in handy when you need to monitor an object over a long period of time. To cancel autofocus, simple click on outside of the object.</p>
                        `
                    }
                }
            ]
        },
        {
            title: {
                ru: 'ÐÐ°Ð½ÐµÐ»Ñ ÐÐ±ÑÐµÐºÑÐ¾Ð²',
                en: 'Object Tool'
            },
            articles: [
                {
                    title: {
                        ru: 'ÐÐ±ÑÐ¸Ðµ ÑÐ²ÐµÐ´ÐµÐ½Ð¸Ñ',
                        en: 'Common information'
                    },
                    content: {
                        ru: `<p>ÐÐ°Ð½ÐµÐ»Ñ Ð¾Ð±ÑÐµÐºÑÐ¾Ð² Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² Ð»ÐµÐ²Ð¾Ð¼ Ð½Ð¸Ð¶Ð½ÐµÐ¼ ÑÐ³Ð»Ñ ÐºÐ°ÑÑÑ. ÐÐµÑÑÐ½Ð¸Ð¹ ÑÑÐ´ ÑÐ¸ÑÑ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð»ÑÐ´ÐµÐ¹, Ð¼Ð°ÑÐ¸Ð½ Ð¸ Ð¼ÐµÑÐ°Ð½Ð¸Ð·Ð¼Ð¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¾ÑÑÐ»ÐµÐ¶Ð¸Ð²Ð°ÑÑÑÑ Ð² ÑÐµÐºÑÑÐ¸Ð¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ. ÐÑÐ°ÑÐ½ÑÐµ ÑÐ¸ÑÑÑ Ð² Ð½Ð¸Ð¶Ð½ÐµÐ¼ ÑÑÐ´Ñ, Ð¾Ð±Ð¾Ð·Ð½Ð°ÑÐ°ÑÑ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¾Ð±ÑÐµÐºÑÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð½Ð° ÐºÐ°ÑÑÐµ (Ð¿Ð¾ ÑÐ°ÑÐ¿Ð¸ÑÐ°Ð½Ð¸Ñ), Ð½Ð¾ Ð¸Ñ Ð¿Ð¾ ÐºÐ°ÐºÐ¸Ð¼-ÑÐ¾ Ð¿ÑÐ¸ÑÐ¸Ð½Ð°Ð¼ ÑÐµÐ¹ÑÐ°Ñ Ð½ÐµÑ.</p>
                        <p>ÐÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð½ÑÐ¶Ð½ÑÑ Ð½Ð°Ð¼ Ð¾Ð±ÑÐµÐºÑÐ¾Ð² Ð¸ Ð¸Ñ ÑÐ²Ð¾Ð¹ÑÑÐ²Ð° Ð¼Ð¾Ð¶Ð½Ð¾ ÐºÐ»Ð¸ÐºÐ½ÑÐ² Ð½Ð° ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÑÑÑÑ Ð¸ÐºÐ¾Ð½ÐºÑ (ÑÐµÐ»Ð¾Ð²ÐµÐºÐ°, Ð¼Ð°ÑÐ¸Ð½Ñ Ð¸Ð»Ð¸ Ð¼ÐµÑÐ°Ð½Ð¸Ð·Ð¼Ð°) Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¾Ð±ÑÐµÐºÑÐ¾Ð².</p>
                        <p>ÐÐ»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ Ð¾Ð±ÑÐµÐºÑÐ°, Ð¼Ñ Ð¼Ð¾Ð¶ÐµÐ¼ Ð¿Ð¾ÑÐ¼Ð¾ÑÑÐµÑÑ ÐµÐ³Ð¾ ÑÐ²Ð¾Ð¹ÑÑÐ²Ð°, ÑÐµÐºÑÑÐµ Ð¼ÐµÑÑÐ¾Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð½Ð° ÐºÐ°ÑÑÐµ, ÐºÐ¾Ð¾ÑÐ´Ð¸Ð½Ð°ÑÑ Ð¸ ÑÑÐ°ÑÑÑ.</p>
                        `,
                        en: `<p>Lets use the Object Tool located at the lower left of the screen to have a closer look at our objects.</p>
                        <p>Here we see how many people, vehicles and assets weâre currently tracking. The red numbers below tell us how many objects need to be there, (by the shift roster, we\'ll talk about it later) but there's no current data from them on the server. Zeros means all good.</p>
                        <p>If we click on the human icon, we will see all the people there. For every person, we can see the Category, Type, Groups it belongs to, hours online (or offline), which tracking device is associated with him or her.</p>
                        <p>We can also see the personâs position on the map right from this tool, and this is real-time picture, it will move with object movements. We can switch to a different person and see their movements from here.</p>
                        <p>We can go back to Monitoring tool by clicking the link in the Tools Panel.</p>
                        <p>If we now click on the vehicle icon in the Object Tool, we will again go to the list, but now there will be only vehicles. Each of them also has a Category and Type, and we can see which groups they belong to. We can also monitor their movements from here, and monitor different equipment from the same place.</p>
                        <p>Here we can see Events and Incidents involving our vehicles. We will talk about Events and Incidents in a separate topic later.</p>
                        <p>And finally, we can we current status of this object: itâs coordinates, speed, direction, and so on.</p>
                        `
                    }
                }
            ]
        },
        {
            title: {
                ru: 'ÐÑÐ°Ð²Ð¸Ð»Ð° Ð´Ð»Ñ ÑÐ¾Ð±ÑÑÐ¸Ð¹ Ð¸ Ð·Ð¾Ð½Ñ',
                en: 'Event rules and zones'
            },
            articles: [
                {
                    title: {
                        ru: 'ÐÐ±ÑÐ¸Ðµ ÑÐ²ÐµÐ´ÐµÐ½Ð¸Ñ',
                        en: 'Common information'
                    },
                    content: {
                        ru: '<iframe width="278" height="156" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/xA2DoLQSarI?rel=0" style="margin: 0 auto;"></iframe>',
                        en: '<iframe width="278" height="156" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/xA2DoLQSarI?rel=0" style="margin: 0 auto;"></iframe>'
                    }
                }
            ]
        }
    ];
    public searchControl = new FormControl();
    public filteredArticles: HelpArticle[];

    @Input() language: string;

    constructor(
        private sanitizer: DomSanitizer,
        private translate: TranslateService,
        public helpPanelService: IqsHelpPanelService
    ) {
        this.translate.setTranslation('ru', helpPanelTranslations.ru, true);
        this.translate.setTranslation('en', helpPanelTranslations.en, true);
        for (const tidx in this.topics) {
            if (!this.topics[tidx]) { continue; }
            for (const aidx in this.topics[tidx].articles) {
                if (!this.topics[tidx].articles[aidx]) { continue; }
                this.topics[tidx].articles[aidx].content.en = <string>this.sanitizer.bypassSecurityTrustHtml(this.topics[tidx].articles[aidx].content.en);
                this.topics[tidx].articles[aidx].content.ru = <string>this.sanitizer.bypassSecurityTrustHtml(this.topics[tidx].articles[aidx].content.ru);
            }
        }

        this.subs.add(this.helpPanelService.state$.subscribe(state => {
            if (state !== HelpPanelState.Search) { this.searchControl.setValue(''); }
        }));

        this.helpPanelService.currentTopic = null;
        this.helpPanelService.state = HelpPanelState.Topics;

        this.subs.add(this.searchControl.valueChanges.pipe(
            debounceTime(200),
            distinctUntilChanged()
        ).subscribe(search => {
            if (search && this.helpPanelService.state !== HelpPanelState.Search) {
                this.helpPanelService.state = HelpPanelState.Search;
            } else if (!search && this.helpPanelService.state === HelpPanelState.Search) {
                this.helpPanelService.state = HelpPanelState.Topics;
            }
            if (search) {
                const articles = [];
                for (const topic of this.topics) {
                    for (const article of topic.articles) {
                        if ((<any>article.content[this.language]).changingThisBreaksApplicationSecurity.match(search)) {
                            articles.push(article);
                        }
                    }
                }
                this.filteredArticles = articles;
            } else {
                this.filteredArticles = [];
            }
        }));
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    public selectTopic(topic: HelpTopic) {
        this.helpPanelService.currentTopic = topic;
    }

    public selectArticle(article: HelpArticle) {
        this.helpPanelService.currentArticle = article;
    }

}
